import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import TopNav from "../components/TopNav";
import "./LogbookPage.css";

const LogbookPage = (props) => {

    const [loading, setLoading] = useState(false);
    // const [error, setError] = useState(false);
    const [data, setData] = useState([]);

    // New State
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [selectedFlight, setSelectedFlight] = useState(null);
    const [reportStatus, setReportStatus] = useState('loading');
    const [reportText, setReportText] = useState(""); // State to store the report text]


    useEffect(() => {
        if (selectedFlight && selectedFlight.url) {
            console.log(selectedFlight.url)
            setReportStatus("loading");
            const fetchReport = async () => {
                const resp = await getReportText( selectedFlight.url );
                console.log(resp)
                setReportText(resp);
            };
            fetchReport();
        }
    }, [selectedFlight]);

    useEffect(() => {
        window.scrollTo(0, 0);
        const localData = localStorage.getItem("logbook");

        if (localData) {
            setData(JSON.parse(localData));
        } else {
            getData();
        }
         return () => {}
    }, []);
    
    const getData = async (obj) => {
      try {
        console.log("test")
        setLoading(true);
        const result = await axios.get("/api/user/get_logbook", {
            params: { _t: Date.now() }
        });        
        const resObj = result.data;
        if (resObj) {
            setData(resObj.logbook);
            localStorage.setItem("logbook", JSON.stringify(resObj.logbook));
            setLoading(false);
        } else {
          console.log("No data");
        }
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    };

    async function getReportText(url){
        try {
            const response = await axios.get("/api/get_report_text", {
                params: { _t: Date.now(), url: url } 
            });
            setReportStatus("success");
            console.log(response.data);
            return response.data; // Return data if needed
        } catch (error) {
            setReportStatus("error");
            console.error("Error fetching report:", error);
        }
    }

    // Calculate flights per day
    // const flightsPerDay = useMemo(() => {
    //     const counts = {};
    //     data.forEach(item => {
    //         if (!item.epoch) return;
    //         let date = new Date(item.epoch);
    //         if (isNaN(date.getTime())) {
    //              date = new Date(parseInt(item.epoch) * 1000);
    //         }
    //         if (!isNaN(date.getTime())) {
    //             const key = date.toDateString();
    //             counts[key] = (counts[key] || 0) + 1;
    //         }
    //     });
    //     return counts;
    // }, [data]);

    // Handlers
    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1);
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleRowClick = (item) => {
        if (item.url) {
            setSelectedFlight(item);
        }
    };

    const closeModal = () => {
        setSelectedFlight(null);
    };

    // Helpers
    const formatDate = (epoch) => {
        if (!epoch) return "";
        // Try parsing as date string first
        let date = new Date(epoch);
        // If invalid, try as timestamp (seconds)
        if (isNaN(date.getTime())) {
             date = new Date(parseInt(epoch) * 1000);
        }
        // If still invalid, return original
        if (isNaN(date.getTime())) return epoch;

        const now = new Date();
        const isCurrentYear = date.getFullYear() === now.getFullYear();

        if (isCurrentYear) {
            return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
        } else {
            return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
        }
    };

    // const getStatusIcon = (status) => {
    //     const s = String(status).toLowerCase();
    //     if (s === 'accepted' || s === 'approved') {
    //         return <span className="lb-status-icon lb-success" title="Accepted">✔</span>;
    //     } else if (s === 'rejected') {
    //         return <span className="lb-status-icon lb-danger" title="Rejected">✖</span>;
    //     } else {
    //         return <span className="lb-status-icon lb-warning" title="Pending">⏳</span>;
    //     }
    // };

    const getRowStatusClass = (status) => {
        const s = String(status || '').toLowerCase();
        if (s === 'accepted' || s === 'approved') return 'lb-row-approved';
        if (s === 'rejected') return 'lb-row-rejected';
        return 'lb-row-pending';
    };

    // Data Processing
    const processedData = useMemo(() => {
        let filtered = [...data];

        // Search
        if (searchQuery) {
            const query = searchQuery.toLowerCase();
            filtered = filtered.filter(item => {
                return (
                    (item.orig && item.orig.toLowerCase().includes(query)) ||
                    (item.dest && item.dest.toLowerCase().includes(query)) ||
                    (item.aircraft && item.aircraft.toLowerCase().includes(query)) ||
                    (item.acmap && item.acmap.toLowerCase().includes(query)) ||
                    (item.logstatus && item.logstatus.toLowerCase().includes(query)) ||
                    (item.frule && item.frule.toLowerCase().includes(query))
                );
            });
        }

        // Sorting
        if (sortConfig.key) {
            filtered.sort((a, b) => {
                const aValue = a[sortConfig.key];
                const bValue = b[sortConfig.key];

                if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
                if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
                return 0;
            });
        }

        return filtered;
    }, [data, searchQuery, sortConfig]);

    // Pagination
    const totalPages = Math.ceil(processedData.length / itemsPerPage);
    const paginatedData = processedData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Columns configuration
    const columns = [
        { 
            key: 'epoch', 
            label: 'Date', 
            className: 'lb-align-left',
            render: (item) => (
                <span className={item.night === 1 ? "lb-date-night" : ""}>
                    {formatDate(item.epoch)}
                </span>
            ) 
        },
        { key: 'orig', label: 'Orig', className: 'lb-align-center' },
        { key: 'dest', label: 'Dest', className: 'lb-align-center' },
        { key: 'aircraft', label: 'Aircraft', className: 'lb-align-left lb-col-spring' },
        { 
            key: 'hours', 
            label: 'Hours', 
            className: 'lb-align-right',
            render: (item) => parseFloat(item.hours || 0).toFixed(1)
        },
        { 
            key: 'nm', 
            label: 'Distance', 
            className: 'lb-align-right',
            render: (item) => parseFloat(item.nm || 0).toFixed(1)
        },
        { key: 'acmap', label: 'AMAP', className: 'lb-align-center' },
        { key: 'logtype', label: 'Flight', className: 'lb-align-left' },
        { 
            key: 'frule', 
            label: 'CONDX',
            className: 'lb-align-center',
            render: (item) => {
                const rule = item.frule ? item.frule.toUpperCase() : "";
                let className = "";
                if (rule === "VFR") className = "lb-frule-vfr";
                else if (rule === "MVFR") className = "lb-frule-mvfr";
                else if (rule === "IFR") className = "lb-frule-ifr";
                else if (rule === "LIFR") className = "lb-frule-lifr";
                return <span className={className}>{item.frule}</span>;
            }
        },
    ];

    return(
        <React.Fragment>
            <TopNav page={props.page} darkMode={props.darkmode} />
            <div className={`lb-wrapper ${props.darkmode ? 'lb-dark' : ''}`}>
                <div className="header">My Logbook</div>

                <div className="lb-container">
                    {/* Search Bar */}
                    <div className="lb-controls">
                        <input
                            type="text"
                            className="lb-search-input"
                            placeholder="Search Origin, Destination, Aircraft, Type, Status, CONDX..."
                            value={searchQuery}
                            onChange={handleSearchChange}
                        />
                        <button className="lb-page-btn" onClick={() => getData()} disabled={loading}>
                            {loading ? 'Refreshing...' : 'Refresh'}
                        </button>
                        {searchQuery && (
                            <div className="lb-search-count">
                                Found {processedData.length} flights
                            </div>
                        )}
                    </div>

                    <div className="lb-table-responsive">
                        <table className="lb-table">
                            <thead>
                                <tr>
                                    {columns.map(col => (
                                        <th key={col.key} className={`lb-th ${col.className || ''}`} onClick={() => handleSort(col.key)}>
                                            <div className="lb-th-content">
                                                {col.label}
                                                {sortConfig.key === col.key && (
                                                    <span className="lb-sort-icon">
                                                        {sortConfig.direction === 'asc' ? ' ▲' : ' ▼'}
                                                    </span>
                                                )}
                                            </div>
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr><td colSpan={columns.length} className="lb-td lb-loading">Loading...</td></tr>
                                ) : paginatedData.length > 0 ? (
                                    paginatedData.map((item, index) => (
                                        <tr 
                                            key={index} 
                                            className={`lb-tr ${item.url ? 'lb-clickable' : ''} ${getRowStatusClass(item.logstatus)}`}
                                            onClick={() => handleRowClick(item)}
                                        >
                                            {columns.map(col => (
                                                <td key={col.key} className={`lb-td ${col.className || ''}`} data-label={col.label}>
                                                    {col.render ? col.render(item) : item[col.key]}
                                                </td>
                                            ))}
                                        </tr>
                                    ))
                                ) : (
                                    <tr><td colSpan={columns.length} className="lb-td lb-no-data">No flights found</td></tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="lb-pagination">
                        <button 
                            className="lb-page-btn" 
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            Previous
                        </button>
                        <span className="lb-page-info">
                            Page {currentPage} of {totalPages || 1}
                        </span>
                        <button 
                            className="lb-page-btn" 
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages || totalPages === 0}
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>

            {/* Modal */}
            {selectedFlight && (
                <div className="lb-modal-overlay" onClick={closeModal}>
                    <div className="lb-modal-content" onClick={e => e.stopPropagation()}>
                        <div className="lb-modal-header">
                            <h3>Flight Report</h3>
                            <button className="lb-close-btn" onClick={closeModal}>&times;</button>
                        </div>
                        <div className="lb-modal-body">
                            {reportStatus === 'loading' && <div className="lb-loading">Loading report...</div>}
                            {reportStatus === 'error' && <div className="lb-error-msg">Flight report was not found</div>}
                            {reportStatus === 'success' && (
                                <div className="lb-report-container">
                                    {reportText && <pre className="lb-report-text">{reportText}</pre>}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>)
}
export default LogbookPage;
